import React from 'react';
import styled from 'styled-components';
import {Assign} from 'utility-types';
import {PrimaryLink} from '../../stories/components/CommonStyleUtils/dwebCommon.styles';

import {EmiDataType} from '../pages/DetailsPage/redux/types';

// COMPONENTS
import StyledModalHeader from './BrandModalHeader';

// CONFIG
import {noCostEMIMarketingLink} from '../config/api-config';

const TnCAsterisk = '*';

const S = {
  ModalHeader: StyledModalHeader,

  Table: styled.table(
    props => `
    width: 90%;
    margin: ${props.theme.spacing.large} auto;

  `,
  ),

  TableHead: styled.thead(
    props => `
    font-size: ${props.theme.font.custom(16)}
  `,
  ),

  TableHeaderRow: styled.tr(
    props => `
    // display: flex;
    // justify-content: space-between;
  `,
  ),

  HeaderCell: styled.th(
    props => `
    text-align: left;
    padding: ${props.theme.spacing.base} 0 ${props.theme.spacing.large} 0;
  `,
  ),

  TableBody: styled.tbody(
    props => `
    margin: ${props.theme.spacing.small} 0 0 0
    font-size: ${props.theme.font.custom(16)}
  `,
  ),

  TableBodyRow: styled.tr(
    props => `

  `,
  ),

  ContentCell: styled.td(
    props => `
    text-align: left;
    padding: ${props.theme.spacing.large} 0
  `,
  ),

  ContentAsterisk: styled.span(
    props => `
    position: relative;
    right: ${props.theme.spacing.custom(4)};
`,
  ),

  AdditionalInfo: styled.div(
    props => `
    padding: ${props.theme.spacing.large} ${props.theme.spacing.custom(30)};
    border-top: .2rem solid ${props.theme.colors.goBrandBlue.light};
  `,
  ),

  Disclaimer: styled.span(
    props => `
    font-size: ${props.theme.font.custom(14)};
  `,
  ),

  AvailabilityText: styled.div(
    props => `
    padding: ${props.theme.spacing.base} 0;
    font-size: ${props.theme.font.custom(14)};
  `,
  ),

  // KnowMoreText: styled.a(
  //   props => `
  //   // font-size: ${props.theme.font.base};
  //   // color: ${props.theme.colors.goBrandBlue.base};
  // `,
  // ),
};

export type RequiredEmiRates = NonNullable<EmiDataType['emiRates']>;

const EMIModal = ({emiRates}: {emiRates: RequiredEmiRates}) => {
  const monthsOfEMI: [3, 6, 9] = [3, 6, 9];

  const emiDataMap = monthsOfEMI.map(el => {
    return {...emiRates, months: el};
  });

  return (
    <>
      <S.ModalHeader>No Emi Cost Options</S.ModalHeader>

      <S.Table>
        <S.TableHead>
          <S.TableHeaderRow>
            <S.HeaderCell>Months</S.HeaderCell>
            <S.HeaderCell>Base Hotel Cost</S.HeaderCell>
            <S.HeaderCell>Hotel Taxes & Fee</S.HeaderCell>
            <S.HeaderCell>Total Cost</S.HeaderCell>
            <S.HeaderCell>Monthly EMI</S.HeaderCell>
          </S.TableHeaderRow>
        </S.TableHead>

        <S.TableBody>
          {emiDataMap.reverse().map(data => {
            const {months, bas, tax, fin, e3, e6, e9} = data;

            let monthlyEmi: number;

            if (months === 3) {
              monthlyEmi = e3;
            }

            if (months === 6) {
              monthlyEmi = e6;
            }

            if (months === 9) {
              monthlyEmi = e9;
            }

            const showTnSAsterisk = months === 6 || months === 9;

            return (
              <S.TableBodyRow key={months}>
                <S.ContentCell>
                  {months} <S.ContentAsterisk>{showTnSAsterisk && TnCAsterisk}</S.ContentAsterisk>
                </S.ContentCell>

                <S.ContentCell>
                  {bas} <S.ContentAsterisk>{showTnSAsterisk && TnCAsterisk}</S.ContentAsterisk>
                </S.ContentCell>

                <S.ContentCell>
                  {tax} <S.ContentAsterisk>{showTnSAsterisk && TnCAsterisk}</S.ContentAsterisk>
                </S.ContentCell>

                <S.ContentCell>
                  {fin} <S.ContentAsterisk>{showTnSAsterisk && TnCAsterisk}</S.ContentAsterisk>
                </S.ContentCell>

                <S.ContentCell>
                  {monthlyEmi} @ No Cost{' '}
                  <S.ContentAsterisk>{showTnSAsterisk && TnCAsterisk}</S.ContentAsterisk>
                </S.ContentCell>
              </S.TableBodyRow>
            );
          })}
        </S.TableBody>
      </S.Table>

      <S.AdditionalInfo>
        <S.Disclaimer>{TnCAsterisk} Available With Select Banks</S.Disclaimer>
        <S.AvailabilityText>No Cost EMI available for 3, 6 & 9 month plans.</S.AvailabilityText>
        <PrimaryLink href={noCostEMIMarketingLink} target="_blank" rel="noopener">
          Know More About No Cost EMI
        </PrimaryLink>
      </S.AdditionalInfo>
    </>
  );
};

export default EMIModal;
